import { createApp } from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import 'bootstrap/dist/css/bootstrap.min.css';
import 'bootstrap/dist/js/bootstrap.bundle.min.js';
import 'datatables.net-dt/css/dataTables.dataTables.css';
import 'croppie/croppie.css'




createApp(App).use(store).use(router).mount('#app')
